import type { Subdomain } from "services/customizationService";

export const getSubdomain = () => {
    const parts: string[] = window.location.hostname
        .replace("www.", "")
        .split(".");
    // subdomain exists only if there are at least 3 parts (foo.qb.live / foo.votebox.live)
    return parts.length > 2 ? parts[0] : undefined;
};

export const getSessionJoinUrl = (codeOnline: string): string =>
    `${window.location.origin}/login/${codeOnline}`;

/**
 * Login URL of the session on the subdomain of its entity, or null when the participant is already on it.
 * Without this check, the subdomain of another entity would display its design for this session.
 */
export const getSessionSubdomainRedirectUrl = (
    sessionSubdomain: Subdomain,
    currentSubdomain?: string,
): string | null => {
    if (
        currentSubdomain &&
        currentSubdomain.toLowerCase() ===
            sessionSubdomain.subdomain.toLowerCase()
    ) {
        return null;
    }

    return `https://${sessionSubdomain.subdomain}.${sessionSubdomain.url.replace("https://", "")}/login/${sessionSubdomain.codeOnline}`;
};

export const getUrl = (): string => {
    const subdomain = getSubdomain();
    if (subdomain) {
        return window.env.REACT_APP_ONLINE_API_BASE_URL.replace(
            "https://",
            `https://${subdomain}.`,
        );
    } else {
        return window.env.REACT_APP_ONLINE_API_BASE_URL;
    }
};
